"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    input: {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        opacity: 0,
        cursor: 'pointer',
        zIndex: 10,
    }
}); });
exports.default = useStyles;
